import { createSlice } from "@reduxjs/toolkit"
import { moveNote } from "./workspaceNoteSlice"
import {ensureWorkspaceTemplate} from "../utils/reduxUtilities"

const initialValue = {
	id: -1
}
const ensureWorkspace = (state, workspaceId) => ensureWorkspaceTemplate(state, workspaceId, initialValue)
export const moveNoteSlice = createSlice({
	name: "moveNote",
	initialState: {
		byWorkspace: {},
	},
	reducers: {
		initializeMovingNote: (state, action) => {
			const {targetNote, workspaceId} = action.payload
			const workspaceState = ensureWorkspace(state, workspaceId)
			workspaceState.id = targetNote
		},
		cancelMovingNote: (state, action) => {
			const workspace = ensureWorkspace(state, action.payload)
			workspace.id = -1
		},
		completeMovingNote: (state, action) => {
			const workspace = ensureWorkspace(state, action.payload)
			workspace.id = -1
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(
				moveNote.fulfilled,
				(state, action) => {
					const workspaceId = action.meta.arg.workspaceId
					moveNoteSlice.caseReducers.completeMovingNote(state, {payload: workspaceId})
				}
			)
			.addCase(
				moveNote.rejected,
				(state, action) => {
					const workspaceId = action.meta.arg.workspaceId
					moveNoteSlice.caseReducers.cancelMovingNote(state, {payload: workspaceId})
				}
			)
	}
})

export const { initializeMovingNote, cancelMovingNote, completeMovingNote } = moveNoteSlice.actions
export const selectMovingNote = (state, workspaceId) => state.moveNote.byWorkspace[workspaceId] ?? initialValue.id
export default moveNoteSlice.reducer